import { useEffect, useState, useRef, useMemo } from "react"
import { Payment } from "./Payment";
import { T } from "react-translator-component";
import { currencyFormat, i18nValue, slugify } from '../functions';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheckSquare,
    faSquare
} from "@fortawesome/free-solid-svg-icons";
import {
    Form
} from "react-bootstrap";
import { isHostzBlackSummit } from "./CheckIn/hotelConditions";

const configPaymentCartDefault = {
    optionPayLater: true,
    isUpselling: false,
    isWebCheckin: false
}

export const PaymentCart = ({ checkIn, data, language, currency, onChangeState, onChangeOmmited, showTotalText = false, config = configPaymentCartDefault, paymentOmmitedFromParent }) => {

    const [detail, setDetail] = useState(data);
    const [cart, setCart] = useState([]);
    const [totalCart, setTotalCart] = useState({});
    const [showPaymentByUpselling, setShowPaymentByUpselling] = useState(null);

    const checkoutRef = useRef(null);
    const [dropinInstance, setDropinInstance] = useState(null);
    const [paymentState, setPaymentState] = useState('initial');
    const [paymentMsg, setPaymentMsg] = useState('');
    const [paymentOmmited, setPaymentOmmited] = useState(false);

    // Si el padre controla "pagar después", usar su valor (ej. al volver con Anterior del footer)
    const effectivePaymentOmmited = paymentOmmitedFromParent !== undefined ? paymentOmmitedFromParent : paymentOmmited;

    const [webCkeckinMode, setWebCheckinMode] = useState(config.isWebCheckin);
    const [upsellingMode, setUpsellingMode] = useState(config.isUpselling);
    const [showOptionNoPayment, setShowOptionNoPayment] = useState(config.optionPayLater);

    // Sincronizar detail con data: array del carro (/pay, check-in) u objeto de upselling
    useEffect(() => {
        if (!data) {
            return;
        }
        if (Array.isArray(data)) {
            setDetail(data);
            return;
        }
        if (config?.isUpselling && typeof data === 'object') {
            setDetail(data);
        }
    }, [data, config?.isUpselling]);

    // Importe upselling desde data para mostrar pago en el primer render (antes de que el effect actualice totalCart)
    const upsellingAmountFromData = useMemo(() => {
        if (!data || !config?.isUpselling || typeof data !== 'object' || Array.isArray(data)) return 0;
        const p = data?.optionSelected?.price ?? data?.price;
        return (Number(p) || 0) * 100;
    }, [data?.optionSelected?.price, data?.price, data?.id, config?.isUpselling]);

    // 4111 1111 1111 1111 (CVC: 737) - Expiry 03/2030

    useEffect(() => {

        let auxShowPayments = null;

        let _cart = {
            checkInId: checkIn.id,
            reference: 'Payment Screen',
            name: '.',
            description: '..',
            amount: 0,
            currency: currency,
            amount: 0,
            amounts: {
                security_deposit: { value: 0, currency: currency },
                webcheckin: { value: 0, currency: currency },
                paymentscreen: { value: 0, currency: currency },
                add_ons: { value: 0, currency: currency }
            },
            add_ons: null
        }
        console.log('HOY - _cart', _cart);
        console.log('HOY - upsellingMode', upsellingMode);
        console.log('HOY - detail', detail);

        if (detail) {

            console.log('HOY - _cart - DETAIL', detail);

            if (upsellingMode) {
                console.log('HOY - upsellingMode', upsellingMode);

                auxShowPayments = {
                    amount: 0,
                    id: "Upsellings",
                    name: T("cups.title"),
                    qty: 0,
                    desc: '',
                    descList: [],
                    inCart: true,
                    isRequired: true
                };

                _cart.reference = "Upselling Payment";

                const _title = i18nValue(detail.optionSelected, 'name', language) || i18nValue(detail, 'title', language);
                let _price = Number(detail?.optionSelected?.price ?? detail?.price ?? 0) || 0;
                let _values = detail.settingData?.values || "";
                let hasKeyTotal = detail.optionSelected?.values?.find?.(item => item.total !== undefined);
                console.log('HOY - hasKeyTotal', hasKeyTotal);
                if (hasKeyTotal) {
                    _price = hasKeyTotal.total;
                    _values = detail.optionSelected?.values || "";
                }
                const _item = {
                    id: detail.id,
                    name: _title,
                    internalKey: checkIn.id + "_upselling_" + (detail.optionSelected?.id || detail.id),
                    slug: slugify(_title),
                    // amount: element.price,
                    coloquial: `${_title} -  ${_price > 0 ? `${currencyFormat(_price, currency)}` : (_price === 0 ? T("general.no-charge") : "")}`,
                    // type: null,
                    // config: null,
                    amount: {
                        valueDecimal: _price,
                        value: _price * 100,
                        currency: currency
                    },
                    values: _values
                }
                auxShowPayments.descList.push(_item);
                auxShowPayments.amount += _price;

                _cart.amount += 100 * _price;
                _cart.add_ons = auxShowPayments.descList;
                _cart.amounts.add_ons.value = auxShowPayments.amount * 100;

                setShowPaymentByUpselling(auxShowPayments);

            } else {

                _cart.amount = detail
                    .filter(item => item.selected && !item.isSecurityDeposit)
                    .reduce((sum, item) => sum + (100 * item.amount), 0);

                _cart.amounts.webcheckin.value = _cart.amount;

                console.log('HOY - _cart filter isSecurityDeposit', detail.filter(item => item.isSecurityDeposit).length);
                const itemsSD = detail.filter(item => item.isSecurityDeposit);
                if (itemsSD.length == 1) {
                    _cart.chargeDepositGuarantee = true;

                    // Condición único item en el carro
                    _cart.onlyDepositGuarantee = detail.filter(item => item.selected).length == 1;
                    // Condición, items en carro pero la suma es cero
                    _cart.onlyDepositGuarantee = _cart.onlyDepositGuarantee || (_cart.amount == 0);

                    _cart.amounts.security_deposit.value = 100 * itemsSD[0].amount;
                } else {
                    _cart.chargeDepositGuarantee = false;
                    _cart.onlyDepositGuarantee = false;
                    _cart.amounts.security_deposit.value = 0;
                }

                console.log('HOY - _cart filter isUpselling', detail.filter(item => item.isUpselling).length);
                const itemsUpsellings = detail.filter(item => item.isUpselling);
                if (itemsUpsellings) {
                    itemsUpsellings.forEach(add_on => {
                        _cart.add_ons = add_on.descList;
                        _cart.amounts.add_ons.value = add_on.amount * 100;
                        _cart.amounts.webcheckin.value -= add_on.amount * 100;
                    })
                }

                // Muestro el monto total (porque solo es SD)
                if (_cart.onlyDepositGuarantee) {
                    _cart.amount = 100 * itemsSD[0].amount;
                }

                // No envío valores negativos
                if (_cart.amounts.webcheckin.value < 0) {
                    _cart.amounts.webcheckin.value = 0;
                }

            }


        }

        console.log('HOY - _cart_in_PaymentCart', _cart)

        if (_cart.amount <= 0) {
            // Sin saldo pendiente => disparo evento
            setPaymentState('no-payment-pending');
        } else {
            // El carro llegó después del primer render vacío (VICO-1430)
            setPaymentState((prev) => (prev === 'no-payment-pending' ? 'initial' : prev));
        }

        setTotalCart(_cart);

    }, [detail]);

    useEffect(() => {
        if (onChangeState) {
            onChangeState(paymentState);
        }
    }, [paymentState]);

    useEffect(() => {
        if (onChangeOmmited) {
            onChangeOmmited(paymentOmmited);
        }
    }, [paymentOmmited]);

    const paymentResult = (res, detail) => {
        console.log('paymentResult - res', res);
        console.log('paymentResult - detail', detail);

        setPaymentMsg('');

        if (res == 'Loading') {
            console.log('setPaymentState', 'loading-component');
            setPaymentState('loading-component');
        }
        if (res == 'InProgress') {
            console.log('setPaymentState', 'in-progress');
            setPaymentState('in-progress');
        }
        if (res == 'Authorised') {
            console.log('setPaymentState', 'done');
            setPaymentState('done');
            // setNextDisabled(false);
        }
        if (res == 'Refused' || res == 'Error') {
            console.log('setPaymentState', 'error');
            setPaymentState('error');

            console.log('paymentResult - ', detail);
            setPaymentMsg('ERRORRRRRRRRRR');
            // setPaymentMsg(detail)
            // setNextDisabled(false);
        }
    }

    const toggleCart = (id) => {
        console.log('toggleCart', id);

        setDetail((prevDetail) =>
            prevDetail.map((el) =>
                el.id === id ? { ...el, selected: !el.selected } : el
            )
        );
    }

    const showPaymentComponent = useMemo(() => {
        let show = (paymentState == "in-progress") || (paymentState == "error") || (paymentState == "done");
        return show;
    }, [paymentState]);



    // TODO_G: VER DE DONDE LO SACAMOS ---- TODO::::: ver luego
    const countryCode = useMemo(() => {
        const cc = checkIn?.passengers?.[0]?.residence || checkIn?.passengers?.[0]?.nationality || null;
        console.log('20ene - cc', cc);
        return cc || "CH";
    }, [checkIn?.passengers]);

    // En upselling, usar importe desde data si totalCart aún no tiene amount (primer render)
    const effectiveAmount = (totalCart.amount != null && totalCart.amount > 0) ? totalCart.amount : (config?.isUpselling ? upsellingAmountFromData : 0);

    return (
        <div className="mb-4">

            <div className="payment-container mb-4">
                <div ref={checkoutRef} className="payment" style={{ display: (showPaymentComponent ? 'block' : 'none') }}>
                </div>
            </div>

            {/* <div>{JSON.stringify(data)}</div>
            <div>Payment state: {paymentState}</div>
            <div>Payment msg: {paymentMsg}</div> */}
            {/* <div>PaymentState {paymentState}</div> */}

            {(paymentState == "initial" || paymentState == "no-payment-pending") && (
                <div>
                    {!upsellingMode && (
                        <>
                            {detail?.lenght > 0 && (
                                <p className="pt-2 general-text-sm text-center">{T("payments.items-pay-with-deposit")}</p>
                            )}

                            <div className="card border-default">
                                {(detail && detail.map((el, idx) => {
                                    const isRequired = el.required || false; // cartRequired.includes(el.id);
                                    const inCart = el.selected || false; // cart.includes(el.id);
                                    return (
                                        <div
                                            key={`balance-detail-${idx}`}
                                            className="text-center"
                                            style={{
                                                background: "white",
                                                color: inCart ? "#5b2e5c" : "#AAA",
                                                borderBottom: "2px solid #F7F7F7",
                                                fontWeight: inCart ? "400" : "lighter",
                                                fontSize: "90%",
                                                // borderRadius: 8,
                                                padding: "6px 10px"
                                            }}
                                            onClick={() => {
                                                if (isRequired) return;
                                                toggleCart(el.id)
                                            }}>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    {!isRequired && (
                                                        <FontAwesomeIcon
                                                            icon={inCart ? faCheckSquare : faSquare}
                                                            style={{ fontSize: 16, color: inCart ? "#5b2e5c" : "#AAA" }}
                                                            className="mr-2"
                                                        />
                                                    )}
                                                    <div className="text-left" style={{ lineHeight: 1 }}>{el.name}
                                                        {el.qty > 1 && (<small>{el.qty && ` (x${el.qty})`}</small>)}
                                                    </div>
                                                </div>
                                                <div>{el.amount.toFixed(2)} {currency}</div>
                                            </div>
                                            {el.desc && (<div className="text-left font-size-sm" style={{ lineHeight: 1 }}><small>{el.desc}</small></div>)}
                                            {el.descList?.map((el1, idx1) => (
                                                <div key={`ups-desc-item-${idx1}`} className="text-left font-size-sm" style={{ lineHeight: 1 }}><small>- {el1.coloquial}</small></div>
                                            ))}
                                        </div>
                                    )
                                }))}
                            </div>
                        </>
                    )}


                    {(upsellingMode && (showPaymentByUpselling || (data && typeof data === 'object' && !Array.isArray(data)))) && (
                        <div
                            className="text-center mb-1"
                            style={{
                                background: "white",
                                color: (showPaymentByUpselling || {}).inCart !== false ? "#5b2e5c" : "#AAA",
                                border: (showPaymentByUpselling || {}).inCart !== false ? "1px solid #5b2e5c" : "1px solid #EEE",
                                fontWeight: (showPaymentByUpselling || {}).inCart !== false ? "bold" : "lighter",
                                borderRadius: 8,
                                padding: "8px 10px"
                            }}
                            onClick={() => {
                                const aux = showPaymentByUpselling;
                                if (aux && !aux.isRequired) {
                                    toggleCart(aux.id);
                                    setShowPaymentByUpselling({ ...aux, inCart: !aux.inCart });
                                }
                            }}>
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex justify-content-between align-items-center">
                                    {(!(showPaymentByUpselling || {}).isRequired) && (
                                        <FontAwesomeIcon
                                            icon={(showPaymentByUpselling || {}).inCart ? faCheckSquare : faSquare}
                                            style={{ fontSize: 16, color: (showPaymentByUpselling || {}).inCart ? "#5b2e5c" : "#AAA" }}
                                            className="mr-2"
                                        />
                                    )}
                                    <div className="text-left" style={{ lineHeight: 1 }}>
                                        {(showPaymentByUpselling?.name) || i18nValue(data?.optionSelected, 'name', language) || i18nValue(data, 'title', language) || ''}
                                        {(showPaymentByUpselling?.qty || 1) > 1 && (<small> (x{showPaymentByUpselling?.qty || 1})</small>)}
                                    </div>
                                </div>
                                <div>{currencyFormat(showPaymentByUpselling?.amount ?? (data?.optionSelected?.price ?? data?.price ?? 0), currency)}</div>
                            </div>
                            {(showPaymentByUpselling?.descList || []).map((el1, idx1) => (
                                <div key={`ups-desc-item-${idx1}`} className="text-left font-size-sm" style={{ lineHeight: 1 }}><small>- {el1.coloquial}</small></div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {paymentState != "done" && (
                <>
                    {/* {paymentState == "error" && (
                        <div>ERRORRRRRRRR</div>
                    )} */}

                    {(effectiveAmount > 0) && (
                        <>
                            {showTotalText && !effectivePaymentOmmited && (
                                <>
                                    {(paymentState === "initial") && <div className="d-flex py-1" style={{ flex: 1, justifyContent: "space-between" }}>
                                        <div className="pl-2"><span className="font-size-sm">{T("general.country")}:</span> <span className="general-text-xl"><b>{countryCode}</b></span></div>
                                        <div className="pr-2"><span className="font-size-sm">{T("payments.total-to-pay")}:</span> <span className="general-text-xl"><b>{(effectiveAmount / 100).toFixed(2)} {currency}</b></span></div>
                                    </div>}
                                </>
                            )}

                            {effectivePaymentOmmited ? (
                                <p className="text-center py-3 text-muted small mb-0">
                                    {T("payments.confirm-pay-later") || "Confirmarás el pedido y pagarás más tarde. Usa el botón Comprar de abajo."}
                                </p>
                            ) : (totalCart.amount > 0) ? (
                                <Payment
                                        text={paymentState != "error" ? T("payments.pay") : T("payments.retry-pay")}
                                        checkInId={checkIn.id}
                                        paymentDetail={totalCart}
                                        paymentResult={paymentResult}
                                        checkoutRef={checkoutRef}
                                        dropinInstance={dropinInstance}
                                        setDropinInstance={setDropinInstance}
                                        countryCode={countryCode}
                                        language={language}
                                    />
                            ) : (
                                <p className="text-center py-2 text-muted small">{T("payments.preparing") || "Preparando opciones de pago..."}</p>
                            )}
                        </>
                    )}

                    {(effectiveAmount <= 0) && (
                        <>
                            <p className="text-center p-4">{T('payments.balance-paid')}</p>
                        </>
                    )}

                </>
            )}



            {showOptionNoPayment && paymentState == "initial" && (
                <legend className="mt-2 mb-0">
                    <Form.Check inline id="payment-ommited">
                        <Form.Check.Input
                            id={`payment-ommited`}
                            className="ml-1 mr-2 custom-checkbox"
                            checked={effectivePaymentOmmited || false}
                            onChange={(event) => {
                                const checked = event.target.checked;
                                if (paymentOmmitedFromParent === undefined) setPaymentOmmited(checked);
                                onChangeOmmited?.(checked);
                            }}
                        />
                        <Form.Check.Label className="font-size-sm text-left paymentCartComponent" style={{ fontSize: "0.95rem" }}>
                            {T("payments.later")}
                        </Form.Check.Label>
                    </Form.Check>
                </legend>
            )}

        </div>
    )
}